import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";
import Box from '@mui/material/Box';
// import Typography from "@mui/material/Typography";
import Collapse from '@mui/material/Collapse';
import {
	resetGetCustomerDetails,
	getCustomerDetails
} from "../../redux/actions/getCustomerDetailsAction";
// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import {
	Grid,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Accordion,
	AccordionSummary,
	AccordionDetails,Typography
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";

import { ExpandMore } from "@mui/icons-material";
import GetAppIcon from "@mui/icons-material/GetApp";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";
  

const useRowStyles = makeStyles({
	root: {
		"& > *": {
			// borderBottom: "unset",
		}
	}
});

function GetCustomerDetails() {
	const location = useLocation();

	const [open, setOpen] = React.useState(false);
	const [getCustomerDetailsStatus, setGetCustomerDetailsStatus] =
		useState(false);
	const [getCustomerDetailsResArray, setGetCustomerDetailsResArray] = useState(
		[]
	);

	const classes = useRowStyles();
	const customerId = location.search.split("?userId=")[1];
	// console.log(customerId);
	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	 const regenerateTokenRes = useSelector(
	 	({ regenerateToken }) => regenerateToken);
	// );
	// var authToken = regenerateTokenRes.data.AuthToken;

    
	// const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    var authToken = regenerateTokenRes.data.AuthToken;

	//const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
	
	//const [token, setToken] = useState("");
  
	const getCustomerDetailsRes = useSelector(
		({ getCustomerDetails }) => getCustomerDetails
	);

	const setGetCustomerDetailsStatusFunc = () => {
		setGetCustomerDetailsStatus(true);
		const getManualDepositListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				custmerId: customerId
			}
		};

		return dispatch(
			getCustomerDetails(
				getManualDepositListReq,
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setGetCustomerDetailsStatusFunc();
		}
	}, [customerId, regenerateTokenRes.data.AuthToken]);

	// console.log(getCustomerDetailsRes, "getCustomerDetailsRes");

	const getCustomerDetailsStatusFunc = () => {
		if (getCustomerDetailsStatus) {
			if (getCustomerDetailsRes.data.status == "Success") {
				setGetCustomerDetailsResArray(getCustomerDetailsRes.data);
			}
			if (getCustomerDetailsRes.data.status == "Failed") {
				setGetCustomerDetailsResArray(getCustomerDetailsRes.data);
				if (
					getCustomerDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getCustomerDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getCustomerDetailsRes.data.status == "failed") {
				setGetCustomerDetailsResArray(getCustomerDetailsRes.data);
				if (
					getCustomerDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getCustomerDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getCustomerDetailsStatusFunc();
	}, [getCustomerDetailsRes.data.status]);

	return (
		<>
			<Layout>
				<BackButton />
				<div className="popup1" style={{ borderRadius: "5px" }}>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}>
						<Typography
							variant="h6"
							component="div"
							className=""
							style={{
								fontSize: "1.4rem",
								marginBottom: "1.2rem",
								color: "#013c83",
								textAlign: "center",
								fontWeight: "600"
							}}
						>
							<Col md={12}>
								{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
									getCustomerDetailsResArray.customerMasterDetailsResponseVO
										.userRole}{" "}
								Details
							</Col>
						</Typography>

						<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMore />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography style={{ color: "#013c83" }}>
									Registration Details
								</Typography>
							</AccordionSummary>
							<AccordionDetails style={{ display: "unset" }}>
								<Typography>
									{/* <Row> */}
									<Col md={12}>
										<Row className="detail-info row">
											<Col md={6}>Agent/Merchant ID:</Col>
											<Col md={6}>
												{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.customerId == ""
													? "-"
													: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.customerId}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Role:</Col>
											<Col md={6}>
												{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.userRole == ""
													? "-"
													: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.userRole}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Entity Type:</Col>
											<Col md={6}>
												{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.entityType == ""
													? "-"
													: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.entityType}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Created By:</Col>
											<Col md={6}>
												{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.initiatedBy == ""
													? "-"
													: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.initiatedBy}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Modified By:</Col>
											<Col md={6}>
												{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.initiatedBy == ""
													? "-"
													: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.initiatedBy}
											</Col>
										</Row>
									</Col>
									{/* </Row> */}
								</Typography>
							</AccordionDetails>
						</Accordion>

						{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
							getCustomerDetailsResArray.customerMasterDetailsResponseVO
								.walletList ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography style={{ color: "#013c83" }}>
											Wallet Balance
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<Table size="medium" aria-label="purchases">
											<TableHead>
												<TableRow className="my-3 tableHeaderColor">
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Store Id
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Currency
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Balance
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO.walletList &&
													[]
														.concat(
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO.walletList
														)
														.map((detail, i) => {
															return (
																<TableRow key={i + 1}>
																	<TableCell
																		style={{
																			width: "35%",
																			textAlign: "center"
																		}}
																	>
																		{/* {`${detail.currency} -  ${detail.balance}`}{" "} */}
																		{detail.storeId == ""
																			? "-"
																			: detail.storeId}
																	</TableCell>
																	<TableCell
																		style={{
																			width: "35%",
																			textAlign: "center"
																		}}
																	>
																		{/* {`${detail.currency} -  ${detail.balance}`}{" "} */}
																		{detail.currency == ""
																			? "-"
																			: detail.currency}
																	</TableCell>
																	<TableCell
																		style={{
																			width: "35%",
																			textAlign: "center"
																		}}
																	>
																		{detail.balance == ""
																			? "-"
																			: detail.balance}
																	</TableCell>
																</TableRow>
															);
														})}
											</TableBody>
										</Table>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
							getCustomerDetailsResArray.customerMasterDetailsResponseVO
								.kycAndKybDetailsList &&
							[].concat(
								getCustomerDetailsResArray.customerMasterDetailsResponseVO
									.kycAndKybDetailsList
							) ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography style={{ color: "#013c83" }}>
											KYC Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
											getCustomerDetailsResArray.customerMasterDetailsResponseVO
												.kycAndKybDetailsList &&
											[]
												.concat(
													getCustomerDetailsResArray
														.customerMasterDetailsResponseVO
														.kycAndKybDetailsList
												)
												.map((details) => {
													return (
														<>
															<div
																style={{
																	// marginTop: "2rem",
																	marginLeft: "1rem",
																	marginRight: "1rem",
																	marginBottom: "2rem"
																}}
															>
																<Accordion>
																	<AccordionSummary
																		expandIcon={<ExpandMore />}
																		aria-controls="panel1a-content"
																		id="panel1a-header"
																	>
																		<Typography style={{ color: "#013c83" }}>
																			{details.action}
																		</Typography>
																	</AccordionSummary>
																	<Typography>
																		<Col md={12}>
																			<Row className="detail-info row">
																				<Col md={6}>ACTION</Col>
																				<Col md={6}>
																					{details.action == ""
																						? "-"
																						: details.action}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Verification ID</Col>
																				<Col md={6}>
																					{details.regFraudId == ""
																						? "-"
																						: details.regFraudId}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Request ID</Col>
																				<Col md={6}>
																					{details.requestId == ""
																						? "-"
																						: details.requestId}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Request status</Col>
																				<Col md={6}>
																					{details.requestStatus == ""
																						? "-"
																						: details.requestStatus}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Request Date</Col>
																				<Col md={6}>
																					{details.requestTime == ""
																						? "-"
																						: details.requestTime}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Response ID</Col>
																				<Col md={6}>
																					{details.responseId == ""
																						? "-"
																						: details.responseId}
																				</Col>
																			</Row>{" "}
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Verification status</Col>
																				<Col md={6}>
																					{details.requestStatus == ""
																						? "-"
																						: details.requestStatus}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>
																					Verification Description
																				</Col>
																				<Col md={6}>
																					{details.description == ""
																						? "-"
																						: details.description}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Verification Type</Col>
																				<Col md={6}>
																					{details.checkType == ""
																						? "-"
																						: details.checkType}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Score</Col>
																				<Col md={6}>
																					{details.fraudScore == ""
																						? "-"
																						: details.fraudScore}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Recommendation</Col>
																				<Col md={6}>
																					{details.recommendation == ""
																						? "-"
																						: details.recommendation}
																				</Col>
																			</Row>{" "}
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Confidence Level</Col>
																				<Col md={6}>
																					{details.confidenceLevel == ""
																						? "-"
																						: details.confidenceLevel}
																				</Col>
																			</Row>{" "}
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Verified On</Col>
																				<Col md={6}>
																					{details.verifiedOn == ""
																						? "-"
																						: details.verifiedOn}
																				</Col>
																			</Row>
																			<hr />
																			<Row className="detail-info row">
																				<Col md={6}>Verified By</Col>
																				<Col md={6}>
																					{details.modifiedBy == ""
																						? "-"
																						: details.modifiedBy}
																				</Col>
																			</Row>
																		</Col>
																	</Typography>
																</Accordion>
															</div>
														</>
													);
												})}
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
							getCustomerDetailsResArray.customerMasterDetailsResponseVO
								.businessAccountMasterVOList ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography style={{ color: "#013c83" }}>
											Company Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<Typography>
											<Col md={12}>
												<Row className="detail-info row">
													<Col md={6}>Company ID</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.companyId == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.companyId}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Company Name</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.companyName == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.companyName}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Organization Type</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.userType == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.userType}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Business Type</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.businessNature == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.businessNature}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>BusinessNature Sub Type</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.businessNatureSubType == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.businessNatureSubType}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>MCC Code</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.mccCode == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.mccCode}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Business Phone Number</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList
																.customerMasterDetailsResponseVO == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList
																.customerMasterDetailsResponseVO}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Outlet Infra</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.outletInfra == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.outletInfra}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Outlet Infra Ownership</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList
																.outletInfraOwnership == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList
																.outletInfraOwnership}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>VAT ID</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.vatNumber == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.vatNumber}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>TAX ID</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.taxNumber == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.taxNumber}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Trade License No</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList.tradeLicenseNumber ==
															""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList
																.tradeLicenseNumber}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Trade License Authority</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList
																.tradeLicenseAuthority == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList
																.tradeLicenseAuthority}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Trade License Validity</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList
																.tradeLicenseValidity == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAccountMasterVOList
																.tradeLicenseValidity}
													</Col>
												</Row>
											</Col>
										</Typography>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
							getCustomerDetailsResArray.customerMasterDetailsResponseVO
								.merchantAddressRequestVOList ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography style={{ color: "#013c83" }}>
											Merchant Owner Address Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<Typography>
											<Col md={12}>
												<Row className="detail-info row">
													<Col md={6}>Address</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList
																.merchantOwnerAddress == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList
																.merchantOwnerAddress}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>District</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList.state == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList.state}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Thana/Upazilla</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList.city == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList.city}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Union/Ward</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList.city == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList.city}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Postal Code</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList.postalCode == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.merchantAddressRequestVOList.postalCode}
													</Col>
												</Row>
											</Col>
										</Typography>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
							getCustomerDetailsResArray.customerMasterDetailsResponseVO
								.businessAddressRequestVOList ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography style={{ color: "#013c83" }}>
											Business Address Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<Typography>
											<Col md={12}>
												<Row className="detail-info row">
													<Col md={6}>Address</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.businessAddress ==
															""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.businessAddress}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Location Type</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.city == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.city}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>District</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.state == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.state}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Thana/Upazilla</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.city == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.city}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Union/Ward</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.city == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.city}
													</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Postal Code</Col>
													<Col md={6}>
														{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.postalCode == ""
															? "-"
															: getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList &&
															getCustomerDetailsResArray
																.customerMasterDetailsResponseVO
																.businessAddressRequestVOList.postalCode}
													</Col>
												</Row>
											</Col>
										</Typography>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{/* {getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
              getCustomerDetailsResArray.customerMasterDetailsResponseVO
                .kycAndKybDetailsList &&
              []
                .concat(
                  getCustomerDetailsResArray.customerMasterDetailsResponseVO
                    .kycAndKybDetailsList
                )
                .map((details) => {
                  return details.action == "Company_Verification" ? (
                    <div
                      style={{
                        marginTop: "2rem",
                        // marginLeft: "1rem",
                        // marginRight: "1rem",
                      }}
                    >
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography style={{ color: "#013c83" }}>
                            {" "}
                            KYB Details
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ display: "unset" }}>
                          <div
                            style={{
                              // marginTop: "2rem",
                              marginLeft: "1rem",
                              marginRight: "1rem",
                            }}
                          >
                            <Accordion>
                              <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                              >
                                <Typography style={{ color: "#013c83" }}>
                                  {details.action}
                                </Typography>
                              </AccordionSummary>
                              <Typography>
                                <Col md={12}>
                                  <Row className="detail-info row">
                                    <Col md={6}>ACTION</Col>
                                    <Col md={6}>{details.action}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Verification ID</Col>
                                    <Col md={6}>{details.regFraudId}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Request ID</Col>
                                    <Col md={6}>{details.requestId}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Request status</Col>
                                    <Col md={6}>{details.requestStatus}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Request Date</Col>
                                    <Col md={6}>{details.requestTime}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Response ID</Col>
                                    <Col md={6}>{details.responseId}</Col>
                                  </Row>{" "}
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Verification status</Col>
                                    <Col md={6}>{details.requestStatus}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Verification Description</Col>
                                    <Col md={6}>{details.description}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Verification Type</Col>
                                    <Col md={6}>{details.checkType}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Score</Col>
                                    <Col md={6}>{details.fraudScore}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Recommendation</Col>
                                    <Col md={6}>{details.recommendation}</Col>
                                  </Row>{" "}
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Confidence Level</Col>
                                    <Col md={6}>{details.confidenceLevel}</Col>
                                  </Row>{" "}
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Verified On</Col>
                                    <Col md={6}>{details.verifiedOn}</Col>
                                  </Row>
                                  <hr />
                                  <Row className="detail-info row">
                                    <Col md={6}>Verified By</Col>
                                    <Col md={6}>{details.modifiedBy}</Col>
                                  </Row>
                                </Col>
                              </Typography>
                            </Accordion>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  ) : (
                    ""
                  );
                })} */}

						{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
							getCustomerDetailsResArray.customerMasterDetailsResponseVO
								.kycAndKybDetailsList &&
							[].concat(
								getCustomerDetailsResArray.customerMasterDetailsResponseVO
									.kycAndKybDetailsList
							) ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography style={{ color: "#013c83" }}>
											KYB Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<Typography>
											<Col md={12}>
												<Row className="detail-info row">
													<Col md={6}>ACTION</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Verification ID</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Request ID</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Request status</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Request Date</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Response ID</Col>
													<Col md={6}>-</Col>
												</Row>{" "}
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Verification status</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Verification Description</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Verification Type</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Score</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Recommendation</Col>
													<Col md={6}>-</Col>
												</Row>{" "}
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Confidence Level</Col>
													<Col md={6}>-</Col>
												</Row>{" "}
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Verified On</Col>
													<Col md={6}>-</Col>
												</Row>
												<hr />
												<Row className="detail-info row">
													<Col md={6}>Verified By</Col>
													<Col md={6}>-</Col>
												</Row>
											</Col>
										</Typography>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{getCustomerDetailsResArray.customerMasterDetailsResponseVO &&
							getCustomerDetailsResArray.customerMasterDetailsResponseVO
								.userMasterKYCVOList &&
							[].concat(
								getCustomerDetailsResArray.customerMasterDetailsResponseVO
									.userMasterKYCVOList
							) ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography
											style={{
												color: "#013c83"
											}}
										>
											Document Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<Col md={12}>
											{/* <Row className="detail-info row" style={{ marginBottom: "2rem" }}>
                          <Col md={4}>Profile Pic:</Col>
                          <Col md={4}>
                            {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((img) => (
                                  <>
                                    <img
                                      src={`data:image/jpeg;base64,${img.selfie}`}
                                      style={{ maxWidth: "100%" }}
                                    />
                                    <br />
                                    <br />
                                  </>
                                ))}
                          </Col>
                          <Col md={4}>
                            {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((download) => (
                                  <>
                                    <a
                                      download={"Profile"}
                                      href={`data:image/jpeg;base64,${download.selfie}`}
                                    >
                                      <GetAppIcon />
                                    </a>
                                    <br />
                                  </>
                                ))}
                          </Col>
                        </Row>
                        <hr />
                        <Row className="detail-info row" style={{ marginBottom: "2rem" }}>
                          <Col md={4}>Signature:</Col>
                          <Col md={4}>
                            {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((img) => (
                                  <>
                                    <img
                                      src={`data:image/jpeg;base64,${img.signature}`}
                                      style={{ maxWidth: "100%" }}
                                    />
                                    <br />
                                    <br />
                                  </>
                                ))}
                          </Col>
                          <Col md={4}>
                            {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((download) => (
                                  <>
                                    <a
                                      download={"Signature"}
                                      href={`data:image/jpeg;base64,${download.signature}`}
                                    >
                                      <GetAppIcon />
                                    </a>
                                    <br />
                                  </>
                                ))}
                          </Col>
                        </Row>
                        <hr />
                        <Row className="detail-info row" style={{ marginBottom: "2rem" }}>
                          <Col md={4}>File Image:</Col>
                          <Col md={4}>
                            {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((img) => (
                                  <>
                                    <img
                                      src={`data:image/jpeg;base64,${img.base64UserPhotoBack}`}
                                      style={{ maxWidth: "100%" }}
                                    />
                                    <br />
                                    <br />
                                  </>
                                ))}
                            {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((name) => (
                                  <h6>{name.userPhotoIdBackFileName}</h6>
                                ))}
                          </Col>
                          <Col md={4}>
                            {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((download) => (
                                  <>
                                    <a
                                      download={download.userPhotoIdBackFileName}
                                      href={`data:image/jpeg;base64,${download.base64UserPhotoBack}`}
                                    >
                                      <GetAppIcon />
                                    </a>
                                    <br />
                                    <br />
                                  </>
                                ))}
                          </Col>
                        </Row>
                        <hr /> */}
											<Row
												className="detail-info row"
												style={{ marginBottom: "2rem" }}
											>
												<Col md={4}>File Image:</Col>
												<Col md={4}>
													{getCustomerDetailsResArray
														.customerMasterDetailsResponseVO
														.userMasterKYCVOList &&
														[]
															.concat(
																getCustomerDetailsResArray
																	.customerMasterDetailsResponseVO
																	.userMasterKYCVOList
															)
															.map((x) => (
																<>
																	<img
																		src={`data:image/jpeg;base64,${x.base64UserPhotoFront}`}
																		style={{ maxWidth: "100%" }}
																	/>
																	<div
																		style={{
																			display: "flex",
																			justifyContent: "space-around",
																			marginTop: "15px"
																		}}
																	>
																		<h6 style={{ display: "inline" }}>
																			{x.userPhotoIdFileName}
																		</h6>
																		<a
																			download={x.userPhotoIdFileName}
																			href={`data:image/jpeg;base64,${x.base64UserPhotoFront}`}
																		>
																			<GetAppIcon />
																		</a>
																	</div>
																	<br />
																	<br />
																</>
															))}

													{/* {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((name) => (
                                  <h6>{name.userPhotoIdFileName}</h6>
                                ))} */}
												</Col>
												<Col md={4}>
													{/* {getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList &&
                              [].concat(getCustomerDetailsResArray.customerMasterDetailsResponseVO.userMasterKYCVOList)
                                .map((download) => (
                                  <>
                                    <a
                                      download={download.userPhotoIdFileName}
                                      href={`data:image/jpeg;base64,${download.base64UserPhotoFront}`}
                                    >
                                      <GetAppIcon />
                                    </a>
                                    <br />
                                    <br />
                                  </>
                                ))} */}
												</Col>
											</Row>
											<br />
										</Col>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}
					</Box>
				</div>
			</Layout>
		</>
	);
}

export default GetCustomerDetails;
